'use strict';

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var errcode = require('err-code');

var pTimeout = require('p-timeout');

var PeerId = require('peer-id');

var PeerInfo = require('peer-info');

var crypto = require('libp2p-crypto');

var c = require('../constants');

var Message = require('../message');

var Query = require('../query');

var utils = require('../utils');

module.exports = function (dht) {
  /**
   * Look if we are connected to a peer with the given id.
   * Returns the `PeerInfo` for it, if found, otherwise `undefined`.
   * @param {PeerId} peer
   * @returns {Promise<PeerInfo>}
   */
  var findPeerLocal = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peer) {
      var p;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dht._log('findPeerLocal %s', peer.toB58String());

              _context.next = 3;
              return dht.routingTable.find(peer);

            case 3:
              p = _context.sent;

              if (!(!p || !dht.peerStore.has(p))) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              return _context.abrupt("return", dht.peerStore.get(p));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function findPeerLocal(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * Get a value via rpc call for the given parameters.
   * @param {PeerId} peer
   * @param {Buffer} key
   * @returns {Promise<Message>}
   * @private
   */


  var getValueSingle = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(peer, key) {
      var msg;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // eslint-disable-line require-await
              msg = new Message(Message.TYPES.GET_VALUE, key, 0);
              return _context2.abrupt("return", dht.network.sendRequest(peer, msg));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getValueSingle(_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * Find close peers for a given peer
   * @param {Buffer} key
   * @param {PeerId} peer
   * @returns {Promise<Array<PeerInfo>>}
   * @private
   */


  var closerPeersSingle = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key, peer) {
      var msg;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dht._log('closerPeersSingle %b from %s', key, peer.toB58String());

              _context3.next = 3;
              return dht.peerRouting._findPeerSingle(peer, new PeerId(key));

            case 3:
              msg = _context3.sent;
              return _context3.abrupt("return", msg.closerPeers.filter(function (pInfo) {
                return !dht._isSelf(pInfo.id);
              }).map(function (pInfo) {
                return dht.peerStore.put(pInfo);
              }));

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function closerPeersSingle(_x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
   * Get the public key directly from a node.
   * @param {PeerId} peer
   * @returns {Promise<PublicKey>}
   * @private
   */


  var getPublicKeyFromNode = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(peer) {
      var pkKey, msg, recPeer;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              pkKey = utils.keyForPublicKey(peer);
              _context4.next = 3;
              return getValueSingle(peer, pkKey);

            case 3:
              msg = _context4.sent;

              if (!(!msg.record || !msg.record.value)) {
                _context4.next = 6;
                break;
              }

              throw errcode("Node not responding with its public key: ".concat(peer.toB58String()), 'ERR_INVALID_RECORD');

            case 6:
              recPeer = PeerId.createFromPubKey(msg.record.value); // compare hashes of the pub key

              if (recPeer.isEqual(peer)) {
                _context4.next = 9;
                break;
              }

              throw errcode('public key does not match id', 'ERR_PUBLIC_KEY_DOES_NOT_MATCH_ID');

            case 9:
              return _context4.abrupt("return", recPeer.pubKey);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function getPublicKeyFromNode(_x6) {
      return _ref4.apply(this, arguments);
    };
  }();

  return {
    /**
     * Ask peer `peer` if they know where the peer with id `target` is.
     * @param {PeerId} peer
     * @param {PeerId} target
     * @returns {Promise<Message>}
     * @private
     */
    _findPeerSingle: function _findPeerSingle(peer, target) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var msg;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                // eslint-disable-line require-await
                dht._log('findPeerSingle %s', peer.toB58String());

                msg = new Message(Message.TYPES.FIND_NODE, target.id, 0);
                return _context5.abrupt("return", dht.network.sendRequest(peer, msg));

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },

    /**
     * Search for a peer with the given ID.
     * @param {PeerId} id
     * @param {Object} options - findPeer options
     * @param {number} options.timeout - how long the query should maximally run, in milliseconds (default: 60000)
     * @returns {Promise<PeerInfo>}
     */
    findPeer: function findPeer(id) {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var options, pi, key, peers, match, query, error, result, success;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                options = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {};
                options.timeout = options.timeout || c.minute;

                dht._log('findPeer %s', id.toB58String()); // Try to find locally


                _context7.next = 5;
                return findPeerLocal(id);

              case 5:
                pi = _context7.sent;

                if (!(pi != null)) {
                  _context7.next = 9;
                  break;
                }

                dht._log('found local');

                return _context7.abrupt("return", pi);

              case 9:
                _context7.next = 11;
                return utils.convertPeerId(id);

              case 11:
                key = _context7.sent;
                peers = dht.routingTable.closestPeers(key, dht.kBucketSize);

                if (!(peers.length === 0)) {
                  _context7.next = 15;
                  break;
                }

                throw errcode(new Error('Peer lookup failed'), 'ERR_LOOKUP_FAILED');

              case 15:
                // sanity check
                match = peers.find(function (p) {
                  return p.isEqual(id);
                });

                if (!(match && dht.peerStore.has(id))) {
                  _context7.next = 19;
                  break;
                }

                dht._log('found in peerStore');

                return _context7.abrupt("return", dht.peerStore.get(id));

              case 19:
                // query the network
                query = new Query(dht, id.id, function () {
                  // There is no distinction between the disjoint paths,
                  // so there are no per-path variables in dht scope.
                  // Just return the actual query function.
                  return /*#__PURE__*/function () {
                    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(peer) {
                      var msg, match;
                      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                        while (1) {
                          switch (_context6.prev = _context6.next) {
                            case 0:
                              _context6.next = 2;
                              return _this._findPeerSingle(peer, id);

                            case 2:
                              msg = _context6.sent;
                              match = msg.closerPeers.find(function (p) {
                                return p.id.isEqual(id);
                              }); // found it

                              if (!match) {
                                _context6.next = 6;
                                break;
                              }

                              return _context6.abrupt("return", {
                                peer: match,
                                queryComplete: true
                              });

                            case 6:
                              return _context6.abrupt("return", {
                                closerPeers: msg.closerPeers
                              });

                            case 7:
                            case "end":
                              return _context6.stop();
                          }
                        }
                      }, _callee6);
                    }));

                    return function (_x7) {
                      return _ref5.apply(this, arguments);
                    };
                  }();
                });
                _context7.prev = 20;
                _context7.next = 23;
                return pTimeout(query.run(peers), options.timeout);

              case 23:
                result = _context7.sent;
                _context7.next = 29;
                break;

              case 26:
                _context7.prev = 26;
                _context7.t0 = _context7["catch"](20);
                error = _context7.t0;

              case 29:
                query.stop();

                if (!error) {
                  _context7.next = 32;
                  break;
                }

                throw error;

              case 32:
                success = false;
                result.paths.forEach(function (result) {
                  if (result.success) {
                    success = true;
                    dht.peerStore.put(result.peer);
                  }
                });

                dht._log('findPeer %s: %s', id.toB58String(), success);

                if (success) {
                  _context7.next = 37;
                  break;
                }

                throw errcode(new Error('No peer found'), 'ERR_NOT_FOUND');

              case 37:
                return _context7.abrupt("return", dht.peerStore.get(id));

              case 38:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[20, 26]]);
      }))();
    },

    /**
     * Kademlia 'node lookup' operation.
     * @param {Buffer} key
     * @param {Object} [options]
     * @param {boolean} [options.shallow] shallow query (default: false)
     * @returns {AsyncIterable<PeerId>}
     */
    getClosestPeers: function getClosestPeers(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        shallow: false
      };
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var id, tablePeers, q, res, sorted, _iterator, _step, pId;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                dht._log('getClosestPeers to %b', key);

                _context9.next = 3;
                return _awaitAsyncGenerator(utils.convertBuffer(key));

              case 3:
                id = _context9.sent;
                tablePeers = dht.routingTable.closestPeers(id, dht.kBucketSize);
                q = new Query(dht, key, function () {
                  // There is no distinction between the disjoint paths,
                  // so there are no per-path variables in dht scope.
                  // Just return the actual query function.
                  return /*#__PURE__*/function () {
                    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(peer) {
                      var closer;
                      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                        while (1) {
                          switch (_context8.prev = _context8.next) {
                            case 0:
                              _context8.next = 2;
                              return closerPeersSingle(key, peer);

                            case 2:
                              closer = _context8.sent;
                              return _context8.abrupt("return", {
                                closerPeers: closer,
                                pathComplete: options.shallow ? true : undefined
                              });

                            case 4:
                            case "end":
                              return _context8.stop();
                          }
                        }
                      }, _callee8);
                    }));

                    return function (_x8) {
                      return _ref6.apply(this, arguments);
                    };
                  }();
                });
                _context9.next = 8;
                return _awaitAsyncGenerator(q.run(tablePeers));

              case 8:
                res = _context9.sent;

                if (!(!res || !res.finalSet)) {
                  _context9.next = 11;
                  break;
                }

                return _context9.abrupt("return", []);

              case 11:
                _context9.next = 13;
                return _awaitAsyncGenerator(utils.sortClosestPeers(Array.from(res.finalSet), id));

              case 13:
                sorted = _context9.sent;
                _iterator = _createForOfIteratorHelper(sorted.slice(0, dht.kBucketSize));
                _context9.prev = 15;

                _iterator.s();

              case 17:
                if ((_step = _iterator.n()).done) {
                  _context9.next = 23;
                  break;
                }

                pId = _step.value;
                _context9.next = 21;
                return pId;

              case 21:
                _context9.next = 17;
                break;

              case 23:
                _context9.next = 28;
                break;

              case 25:
                _context9.prev = 25;
                _context9.t0 = _context9["catch"](15);

                _iterator.e(_context9.t0);

              case 28:
                _context9.prev = 28;

                _iterator.f();

                return _context9.finish(28);

              case 31:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[15, 25, 28, 31]]);
      }))();
    },

    /**
     * Get the public key for the given peer id.
     * @param {PeerId} peer
     * @returns {Promise<PubKey>}
     */
    getPublicKey: function getPublicKey(peer) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var info, pk, pkKey, value;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                dht._log('getPublicKey %s', peer.toB58String()); // local check


                if (!dht.peerStore.has(peer)) {
                  _context10.next = 8;
                  break;
                }

                info = dht.peerStore.get(peer);

                if (!(info && info.id.pubKey)) {
                  _context10.next = 6;
                  break;
                }

                dht._log('getPublicKey: found local copy');

                return _context10.abrupt("return", info.id.pubKey);

              case 6:
                _context10.next = 9;
                break;

              case 8:
                info = dht.peerStore.put(new PeerInfo(peer));

              case 9:
                _context10.prev = 9;
                _context10.next = 12;
                return getPublicKeyFromNode(peer);

              case 12:
                pk = _context10.sent;
                _context10.next = 22;
                break;

              case 15:
                _context10.prev = 15;
                _context10.t0 = _context10["catch"](9);
                // try dht directly
                pkKey = utils.keyForPublicKey(peer);
                _context10.next = 20;
                return dht.get(pkKey);

              case 20:
                value = _context10.sent;
                pk = crypto.keys.unmarshalPublicKey(value);

              case 22:
                info.id = new PeerId(peer.id, null, pk);
                dht.peerStore.put(info);
                return _context10.abrupt("return", pk);

              case 25:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[9, 15]]);
      }))();
    }
  };
};